const baseURL = `${process.env.NEXT_PUBLIC_GOOGLE_CDN}/images/tutorials`;

const responsiveImage = (name: string, alt: string) => `
  <div class="block sm:hidden">
    <img src="${baseURL}/${name}Mobile.webp" alt="${alt}" class="w-full" />
  </div>
  <div class="hidden sm:block">
    <img src="${baseURL}/${name}Desktop.webp" alt="${alt}" class="w-full" />
  </div>
`;

// Responsive tutorials that will display different images based on screen size
export const TUTORIALS = [
  {
    question: 'How To Navigate?',
    answer: responsiveImage('tutorialNavigate', 'How to navigate'),
  },
  {
    question: 'How to Use the Portal?',
    answer: responsiveImage('tutorialPortal', 'How to use the portal'),
  },
];
